module.exports = __webpack_public_path__ + "img/product.3c54cb59.jpg";